import React, { Fragment } from 'react';
import { Image } from '../../../../../../wag-react/next-components/image';
import { WellnessPlanBenefits, WellnessPlanNames, WELLNESS_PLANS } from '../../data';
import { WellnessLabel } from '../WellnessLabel';
import { WellnessPlanPriceSection } from '../WellnessPlan/WellnessPlanPriceSection';
import { QuestionFilledIcon } from '../../../../../../wag-react/next-components/icons';
import { BoxProps } from '../../../../../../wag-react/next-components/box';
import { Table, TableBody, TableCell, TableHead, TableRow } from '../../../../../../wag-react/core-components/table';
import { Typography } from '../../../../../../wag-react/components/Typography';
export type WellnessPlanTableProps = {
  onIconClick: (benefitName: string) => void;
} & BoxProps;
export const WellnessPlanTable = ({
  onIconClick,
  ...rest
}: WellnessPlanTableProps) => {
  const planDiamond = WELLNESS_PLANS[WellnessPlanNames.Diamond];
  const planGold = WELLNESS_PLANS[WellnessPlanNames.Gold];
  const planPlatinum = WELLNESS_PLANS[WellnessPlanNames.Platinum];
  return <Table style={{
    'table-layout': 'fixed'
  }} {...rest} data-sentry-element="Table" data-sentry-component="WellnessPlanTable" data-sentry-source-file="index.tsx">
      <TableHead data-sentry-element="TableHead" data-sentry-source-file="index.tsx">
        <TableRow data-sentry-element="TableRow" data-sentry-source-file="index.tsx">
          <TableCell component="th" borderRight="1px solid #e8e8e8" verticalAlign="top" data-sentry-element="TableCell" data-sentry-source-file="index.tsx">
            <Image src={planGold.icon} alt={planGold.iconAlt} height="42px" width="42px" data-sentry-element="Image" data-sentry-source-file="index.tsx" />

            <Typography color="#4669B2" fontSize="22px" fontFamily="muliBold" m={0} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              {planGold.title}
            </Typography>

            <Typography fontWeight="400" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              {planGold.description}
            </Typography>
          </TableCell>

          <TableCell component="th" borderRight="1px solid #e8e8e8" position="relative" verticalAlign="top" data-sentry-element="TableCell" data-sentry-source-file="index.tsx">
            <WellnessLabel text={planPlatinum.label} data-sentry-element="WellnessLabel" data-sentry-source-file="index.tsx" />

            <Image src={planPlatinum.icon} alt={planPlatinum.iconAlt} height="42px" width="42px" data-sentry-element="Image" data-sentry-source-file="index.tsx" />

            <Typography color="#4669B2" fontSize="22px" fontFamily="muliBold" m={0} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              {planPlatinum.title}
            </Typography>

            <Typography fontWeight="400" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              {planPlatinum.description}
            </Typography>
          </TableCell>

          <TableCell component="th" verticalAlign="top" data-sentry-element="TableCell" data-sentry-source-file="index.tsx">
            <Image src={planDiamond.icon} alt={planDiamond.iconAlt} height="42px" width="42px" data-sentry-element="Image" data-sentry-source-file="index.tsx" />

            <Typography color="#4669B2" fontSize="22px" fontFamily="muliBold" m={0} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              {planDiamond.title}
            </Typography>

            <Typography fontWeight="400" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              {planDiamond.description}
            </Typography>
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody data-sentry-element="TableBody" data-sentry-source-file="index.tsx">
        {Object.keys(WellnessPlanBenefits).map(key => <Fragment key={key}>
            <TableRow bg="backgroundGray">
              <TableCell colSpan="3" p={2} position="relative">
                <Typography fontWeight="600" textAlign="center" m={0}>
                  {WellnessPlanBenefits[key]}
                </Typography>

                <QuestionFilledIcon cursor="pointer" position="absolute" right="12px" top="50%" style={{
              transform: 'translateY(-50%)'
            }} onClick={() => onIconClick(WellnessPlanBenefits[key])} />
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell borderRight="1px solid #E8E8E8" p={2}>
                <Typography m={0} textAlign="center">
                  {planGold.benefits[WellnessPlanBenefits[key]]}
                </Typography>
              </TableCell>

              <TableCell borderRight="1px solid #E8E8E8" p={2}>
                <Typography m={0} textAlign="center">
                  {planPlatinum.benefits[WellnessPlanBenefits[key]]}
                </Typography>
              </TableCell>

              <TableCell p={2}>
                <Typography m={0} textAlign="center">
                  {planDiamond.benefits[WellnessPlanBenefits[key]]}
                </Typography>
              </TableCell>
            </TableRow>
          </Fragment>)}

        <TableRow borderTop="1px solid #E8E8E8" data-sentry-element="TableRow" data-sentry-source-file="index.tsx">
          <TableCell pt={0} px={2} pb={2} data-sentry-element="TableCell" data-sentry-source-file="index.tsx">
            <WellnessPlanPriceSection value={{
            price: planGold.price,
            buttonHref: planGold.buttonHref
          }} data-sentry-element="WellnessPlanPriceSection" data-sentry-source-file="index.tsx" />
          </TableCell>

          <TableCell pt={0} px={2} pb={2} data-sentry-element="TableCell" data-sentry-source-file="index.tsx">
            <WellnessPlanPriceSection value={{
            price: planPlatinum.price,
            buttonHref: planPlatinum.buttonHref
          }} data-sentry-element="WellnessPlanPriceSection" data-sentry-source-file="index.tsx" />
          </TableCell>

          <TableCell pt={0} px={2} pb={2} data-sentry-element="TableCell" data-sentry-source-file="index.tsx">
            <WellnessPlanPriceSection value={{
            price: planDiamond.price,
            buttonHref: planDiamond.buttonHref
          }} data-sentry-element="WellnessPlanPriceSection" data-sentry-source-file="index.tsx" />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>;
};